import React, { useContext } from 'react';
import CurrencyFormat from 'react-currency-format';
import MainContext from 'MainContext';
import { currencies } from 'utils/currencies';

const Currency = (props) => {
  //currencyToggleRightPos
  const { profile } = useContext(MainContext).login;
  const { currency, currencyToggleRightPos, language } = useContext(MainContext).login.shop_profile;
  const symbol = currency.symbol;
  let { value } = props;
  value=Math.round(value * 100) / 100;

  return (
    <div>
      {
        (!currencyToggleRightPos) ?
        (<span style={{display:'inline-block'}}>{symbol} </span>)
        :(<></>)
      }
      <span><CurrencyFormat
        value={value}
        thousandSeparator={true}
        displayType={'text'}
        renderText={(value) => ' '+value+' '}
        // prefix=
      />
      </span>
      {
        (currencyToggleRightPos) ?
        (<span style={{display:'inline-block'}}>{symbol} </span>)
        :(<></>)
      }

      
    </div>
  );
};

export default Currency;
